/**
 * An enumeration of the different virtual background types.
 *
 * @enum {string}
 */
export const VIRTUAL_BACKGROUND_TYPE = {
	IMAGE: 'image',
	DESKTOP_SHARE: 'desktop-share',
	BLUR: 'blur',
	NONE: 'none',
}
